import { useSelector } from 'react-redux';

import { selectAuctionInfo } from 'redux/slices/auction-info/selectors';

import styles from './header.module.scss';

export function Header() {
  const auctionInfo = useSelector(selectAuctionInfo);
  const { houseName, eventTitle, address, eventDateTime } = auctionInfo || {};

  return (
    <div className={styles['header']}>
      <div className={styles['logo']}>
        <img src='/images/logo-inv.png' alt='logo' />
      </div>
      <div className={styles['auction-detail-section']}>
        <ul className={styles['auction-detail']}>
          <li className={styles['auction-name']}>
            <span>{houseName}</span>
          </li>
          <li>
            <span>{eventTitle}</span>
          </li>
          <li>
            <span>{eventDateTime}</span>
          </li>
          <li>
            <span>{address}</span>
          </li>
        </ul>
      </div>
    </div>
  );
}
